"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postRobotSend = exports.createIframeBridge = void 0;
var post_robot_1 = require("post-robot");
Object.defineProperty(exports, "postRobotSend", { enumerable: true, get: function () { return post_robot_1.send; } });
var utils_1 = require("../../utils");
var setupMessageListeners = function (window, domain, listeners) {
    return Object.entries(listeners).map(function (_a) {
        var eventKey = _a[0], eventHandler = _a[1];
        return (0, post_robot_1.on)(eventKey, {
            window: window,
            domain: domain
        }, function (event) {
            if (eventHandler && event.origin === domain) {
                return eventHandler(event);
            }
        });
    });
};
var createIframeBridge = function (options) {
    if (!options.withWindow) {
        throw new Error('Target window to setup the bridge with is not defined');
    }
    var bridge = {
        open: function () {
            var withWindow = options.withWindow, withDomain = options.withDomain, features = options.features, theme = options.theme, surfaceColor = options.surfaceColor, sendHandshakeMetric = options.sendHandshakeMetric, metadata = options.metadata, shouldReceiveEmbeddedMacroMessages = options.shouldReceiveEmbeddedMacroMessages;
            var listeners = setupMessageListeners(withWindow, withDomain, features);
            // Set up listener for messages forwarded from FAUS (nested embedded macros)
            var cancelEmbeddedMacroHandler;
            if (shouldReceiveEmbeddedMacroMessages && metadata.localId) {
                try {
                    var productHostname_1 = window.location.hostname;
                    var handler = (0, post_robot_1.on)("messageFromEmbeddedFAUS_".concat(metadata.localId), {}, function (event) {
                        var originUrl = new URL(event.origin);
                        if (originUrl.hostname !== productHostname_1) {
                            return;
                        }
                        var _a = event.data || {}, eventKey = _a.eventKey, payload = __rest(_a, ["eventKey"]);
                        var handler = features[eventKey];
                        if (handler) {
                            return handler(__assign(__assign({}, event), { data: payload }));
                        }
                    });
                    cancelEmbeddedMacroHandler = handler.cancel;
                }
                catch (error) {
                    // Log error but don't throw - listener setup failure shouldn't break the app
                    // eslint-disable-next-line no-console
                    console.error("Failed to set up messageFromEmbeddedFAUS listener for localId ".concat(metadata.localId, ":"), error);
                }
            }
            // We only listen for the READY_EVENT fired from the iframe to support hot-reloading via
            // the tunnel. Without this code the hot-reloading would not work. However we do not need
            // to send success / failure analytics as this is only relied upon during development and
            // not in production
            var cancelReadyHandler = (0, post_robot_1.on)(utils_1.READY_EVENT, { window: withWindow, domain: withDomain }, function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, true];
            }); }); }).cancel;
            // This is the main READY_EVENT that we rely on in production to establish the bridge
            // We send an analytics event to indicate whether this handshake procedure was successful
            // or not and this is how we measure the reliability of the bridge. If an error argument
            // is not sent then the handshake was successful, when we send the caught error it was not
            (0, post_robot_1.send)(withWindow, utils_1.READY_EVENT, __assign({ theme: theme, surfaceColor: surfaceColor }, (options.metadata || {})), { timeout: utils_1.BRIDGE_HANDSHAKE_TIMEOUT_MS })
                .then(function () {
                sendHandshakeMetric(true);
            })
                .catch(function (error) {
                sendHandshakeMetric(false, error);
                return (0, utils_1.handleMissingHandlerError)(error);
            });
            return {
                enableTheming: function () {
                    void (0, post_robot_1.send)(withWindow, utils_1.THEME_ENABLE_EVENT).catch(utils_1.handleMissingHandlerError);
                },
                setTheme: function (theme, surfaceColor, env) {
                    void (0, post_robot_1.send)(withWindow, utils_1.THEME_CHANGE_EVENT, {
                        theme: theme,
                        surfaceColor: surfaceColor,
                        env: env,
                        isFedRamp: metadata.isFedRamp
                    }).catch(utils_1.handleMissingHandlerError);
                },
                close: function () {
                    cancelReadyHandler();
                    cancelEmbeddedMacroHandler === null || cancelEmbeddedMacroHandler === void 0 ? void 0 : cancelEmbeddedMacroHandler();
                    listeners.forEach(function (_a) {
                        var cancel = _a.cancel;
                        return cancel();
                    });
                }
            };
        }
    };
    return bridge;
};
exports.createIframeBridge = createIframeBridge;
